export const programId = '5d407440a6a80f20813579ab';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    useFingerprinting: 'true',
    logLevel: 'error',

};
